// Drawer opener
class DrawerOpener extends HTMLElement {
  constructor() {
    super();
    this.drawerBaseUrl = null;
    this.section = null;
    this.fetchUrl = null;
  }

  connectedCallback() {
    this.drawerBaseUrl = this.dataset.drawerBaseUrl;
    this.section = this.dataset.section;
    this.variantId = this.dataset.variantId;
    this.init();
  }

  init() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.openDrawer();
    });
  }

  openDrawer() {
    const drawerWrapper = document.querySelector(".custom_drawer_wrapper");

    if (this.drawerBaseUrl && this.section) {
      if (!this.variantId) {
        this.fetchUrl = `${this.drawerBaseUrl}?section_id=${this.section}`;
      } else {
        this.fetchUrl = `${this.drawerBaseUrl}?section_id=${this.section}&variant=${this.variantId}`;
      }

      fetch(this.fetchUrl)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          const drawerContent = doc.querySelector(".shopify-section").innerHTML;
          drawerWrapper.querySelector(".custom_drawer").innerHTML = drawerContent;
          drawerWrapper.classList.add("open");

          $(drawerWrapper).css("display", "flex").hide().fadeIn();
        });
    }
  }
}

// Enregistrer le Custom Element
customElements.define("drawer-opener", DrawerOpener);

// Drawer Custom
class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    this.fetchUrl = null;
    this.baseUrl = null;
    this.variantId = null;
    this.availableLabel = "";
    this.closeButton = this.querySelector(".custom_drawer_header_close");
    this.wrapper = this.closest(".custom_drawer_wrapper");
    this.overlay = this.wrapper.querySelector(".custom_drawer_overlay");
    this.storesContainer = this.querySelector(".physical_stores_availability");
    this.noVariantsEl = this.querySelector(".no_variants_available");
    this.noSearchResultsEl = this.querySelector(".no_search_results");
    this.searchInput = this.querySelector(".custom_drawer_search_input");
    this.priceEl = this.querySelector("[data-price]");
    this.variantButtons = this.querySelectorAll(".custom_drawer_variant");
  }

  connectedCallback() {
    this.fetchUrl = this.dataset.src;
    this.baseUrl = this.dataset.baseUrl;
    this.variantId = this.dataset.variantId;
    this.availableLabel = this.dataset.availableLabel || "";

    this.closeButton.addEventListener("click", this.close.bind(this));
    this.overlay.addEventListener("click", this.close.bind(this));

    this.variantButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.onVariantClick(btn));
    });

    if (this.searchInput) {
      this.searchInput.addEventListener("input", () => this.applySearch());
    }

    this.fetchData();
  }

  onVariantClick(btn) {
    const newVariantId = btn.dataset.variantId;
    if (!newVariantId || newVariantId === this.variantId) return;

    this.variantId = newVariantId;
    this.variantButtons.forEach((b) => b.classList.toggle("is-active", b === btn));

    if (this.priceEl && btn.dataset.variantPrice) {
      this.priceEl.innerHTML = btn.dataset.variantPrice;
    }

    if (this.baseUrl) {
      this.fetchUrl = `${this.baseUrl}${newVariantId}`;
    }

    if (this.searchInput) this.searchInput.value = "";
    this.fetchData();
  }

  fetchData() {
    this.storesContainer.innerHTML = "";
    this.noVariantsEl.style.display = "none";
    if (this.noSearchResultsEl) this.noSearchResultsEl.style.display = "none";
    this.storesContainer.style.display = "none";

    fetch(this.fetchUrl)
      .then((response) => response.json())
      .then((data) => {
        if (!data || Object.keys(data).length === 0) {
          this.noVariantsEl.style.display = "block";
          return;
        }

        Object.keys(data).forEach((key) => {
          const location = data[key];
          const collapsibleContent = document.createElement("collapsible-content");
          collapsibleContent.classList.add("collapsible_content");
          collapsibleContent.dataset.name = (location.name || "").toLowerCase();
          collapsibleContent.innerHTML = `
            <div class="collapsible_title">
              <p>${location.name}</p>
              <span class="collapsible_status">${this.availableLabel}</span>
              <span class="collapsible_chevron"><svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L4 4L1 1" stroke="#1D1F2A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
            </div>
            <div class="collapsible_content_inner">
              <p>${window.translations.store_availability_sizes_available} ${location.variants_available.map((variant) => variant.name).join(", ")}</p>
              <p>${location.adresse.join("<br>")}</p>
              <p>${location.phone}</p>
            </div>
          `;
          this.storesContainer.appendChild(collapsibleContent);
        });

        this.storesContainer.style.display = "block";
        this.applySearch();
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  applySearch() {
    if (!this.searchInput) return;
    const term = this.searchInput.value.trim().toLowerCase();
    const items = this.storesContainer.querySelectorAll(".collapsible_content");
    let visible = 0;

    items.forEach((item) => {
      const match = !term || (item.dataset.name || "").includes(term);
      item.style.display = match ? "" : "none";
      if (match) visible++;
    });

    if (this.noSearchResultsEl) {
      this.noSearchResultsEl.style.display = term && visible === 0 ? "block" : "none";
    }
  }

  close() {
    this.wrapper.classList.remove("open");
    $(this.wrapper).hide();
  }
}

customElements.define("custom-drawer", CustomDrawer);
